import { createContext, useReducer } from 'react';

import { Drawer } from '../drawer';
// ! DEPRECATED 18-02-2026
// import NotificationDrawer from './drawer';
import { ClipLoader } from '@lua-frontend/numu-ui';

import {
  notificationPanelInitialState,
  notificationPanelActions,
  notificationPanelReducer
} from './context';
import Header from './header';
import { FormattedMessage } from 'react-intl';
import { NotificationTemplate } from './template/notification-template';
import './template/style.scss';

const NotificationPanelContext = createContext();

const NotificationPanelProvider = ({ children, service, list, BASE_URL = '' }) => {
  const [state, dispatch] = useReducer(notificationPanelReducer, notificationPanelInitialState);
  const { showNotificationPanel, pagination } = state;

  const value = {
    dispatch,
    ...state,
    ...notificationPanelActions,
    service,
    list
  };

  const notificationsList = state.notifications?.map((notification) => {
    const recipient = notification.recipients?.[0];

    let key = 'admin-notification-template-list-' + notification.id;
    key += '-' + recipient?.isRead;
    key += '-' + recipient?.isArchived;

    return (
      <NotificationTemplate
        key={key}
        notification={notification}
        recipient={recipient}
        BASE_URL={BASE_URL}
      />
    );
  })

  return (
    <NotificationPanelContext.Provider value={value}>
      {children}
      <Drawer
        open={showNotificationPanel}
        onClose={() => dispatch(notificationPanelActions.setShowNotificationPanel(false))}
        title="Notifications"
      >
        <Header
          isOpen={showNotificationPanel}
          service={service}
          filterOptions={state.filterOptions}
          dispatch={dispatch}
          notifications={state.notifications}
          pagination={pagination}
        />
        <div className="notification-card-list">
          {notificationsList}

          {pagination.isLoading ? (
            <div className={`notification-card-list--loading ${state.notifications.length === 0 ? 'notification-card-list--empty' : ''}`}>
              <p><ClipLoader size={20} color="var(--grey-40)" /></p>
            </div>
          ): state.notifications.length === 0 ? (
            <div className="notification-card-list--empty">
              <p><FormattedMessage id="notification.list.empty" defaultMessage="No notifications available" /></p>
            </div>
          ): null}
          {pagination.hasMore && !pagination.isLoading && state.notifications.length > 0 && (
            <div className="notification-card-list__load-more">
              <button
                type="button"
                className="notification-card-list__load-more-button"
                onClick={async () => {
                  dispatch(
                    notificationPanelActions.updatePagination({ isLoading: true })
                  )
                }}
                disabled={pagination.isLoading}
              >
                <FormattedMessage id="notification.load.more" defaultMessage="Load More" />
              </button>
            </div>
          )}
        </div>
      </Drawer>
    </NotificationPanelContext.Provider>
  );
};

export { NotificationPanelProvider, NotificationPanelContext, notificationPanelActions };
